import React from 'react';

const PolicyPageLayout = ({ title, children }) => {
  return (
    <div className="bg-gray-50 py-16 sm:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white p-8 sm:p-12 shadow-lg rounded-lg">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight border-b pb-4 mb-8">
          {title}
        </h1>
        <div className="prose prose-lg max-w-none text-gray-700">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PolicyPageLayout;